import StarRatings from './StarRatings';
export default StarRatings;
